/* Quiet film controls outside campaign links. Existing video-player owns
   loading, viewport autoplay and the reduced-motion preference. */
(() => {
  if (window.SMHomepageFilm) return;
  const bound = new WeakSet();
  function initialise(scope = document) {
    const features = scope.matches?.('[data-sm-film-feature]')
      ? [scope] : scope.querySelectorAll('[data-sm-film-feature]');
    features.forEach((feature) => {
      const player = feature.querySelector('video-player');
      const video = player?.querySelector('video');
      const button = feature.querySelector('[data-sm-film-toggle]');
      const status = feature.querySelector('[data-sm-film-status]');
      if (!video || !button || bound.has(button)) return;
      bound.add(button);
      video.id ||= `${feature.id}-film`;
      button.setAttribute('aria-controls', video.id);
      const sync = () => {
        const label = video.paused || video.ended ? 'Play film' : 'Pause film';
        button.textContent = label;
        button.setAttribute('aria-label', `${label}: ${feature.dataset.filmLabel || 'House of SM'}`);
        // No hover controls over the campaign. The separate keyboard-accessible
        // button remains available if browser autoplay is refused.
        video.controls = false;
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      // The generic player may enable native controls after an autoplay
      // rejection. This feature has its own persistent control, so keep the
      // campaign surface clear in that case too.
      const nativeControls = new window.MutationObserver(() => {
        if (video.hasAttribute('controls')) video.removeAttribute('controls');
      });
      nativeControls.observe(video, { attributes: true, attributeFilter: ['controls'] });
      video.addEventListener('error', () => {
        status.textContent = 'The film could not load. You can still explore the House using the link above.';
        sync();
      });
      button.addEventListener('click', async () => {
        button.disabled = true;
        status.textContent = '';
        try {
          if (typeof player.togglePlayPause === 'function') {
            await player.togglePlayPause();
          } else if (video.paused) {
            // A customer can activate the control before component-loader has
            // upgraded this below-fold player. Keep that first click useful.
            let needsLoad = false;
            video.querySelectorAll('source[data-src]').forEach((source) => {
              source.src = source.dataset.src;
              delete source.dataset.src;
              needsLoad = true;
            });
            if (needsLoad) video.load();
            player.userPaused = false;
            video.muted = true;
            await video.play();
          } else {
            player.userPaused = true;
            video.pause();
          }
          if (video.paused && !player.userPaused) {
            status.textContent = 'The film could not start. Please try again.';
          }
        } catch (_) {
          status.textContent = 'The film could not start. Please try again.';
        } finally {
          button.disabled = false;
          sync();
        }
      });
      button.closest('.sm-image-feature__film-controls').hidden = false;
      sync();
    });
  }
  window.SMHomepageFilm = { initialise };
  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
